import React from 'react';
import { Callout, DocHeading, QuickCard, ICONS } from './components';

function PageIntroduction({ navigate }) {
  const cards = [
    { icon: ICONS.rocket,   title: 'Get Started',       desc: 'System requirements, installation steps, and your first launch.',  page: 'installation' },
    { icon: ICONS.key,      title: 'Activate Key',       desc: 'How to redeem your license key and bind it to your hardware ID.',    page: 'activate-key' },
    { icon: ICONS.features, title: 'Features',           desc: 'Full overview of all automation features with links to individual guides.', page: 'features' },
    { icon: ICONS.warning,  title: 'Troubleshooting',    desc: 'Common errors, HWID issues, and loader error code reference.',      page: 'common-errors' },
    { icon: ICONS.headset,  title: 'Support',            desc: 'Reach out to our team directly on Discord.',                        page: null, discord: true },
  ];

  return (
    <div>
      <p className="text-sm text-brand-400 font-medium mb-2">Get Started</p>
      <h1 className="font-display text-3xl font-bold text-white tracking-tight mb-3">Introduction</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        Welcome to the MortisEngine documentation. This guide covers everything you need to get
        up and running with the most advanced Drakensang Online automation tool on the market —
        from initial setup to configuration.
      </p>

      <DocHeading>Quick Links</DocHeading>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map(c => (
          <QuickCard
            key={c.title}
            icon={c.icon}
            title={c.title}
            desc={c.desc}
            onClick={c.page ? () => navigate(c.page) : undefined}
          />
        ))}
      </div>

      <Callout type="warning">
        Please read through the documentation thoroughly before contacting support. Do not skip
        steps — most issues are caused by missed installation requirements.
      </Callout>

      <DocHeading>Need Further Assistance?</DocHeading>
      <p className="text-gray-400 text-sm mb-5">
        If you have read all the relevant sections and your issue still persists, reach out via
        the channels below.
      </p>
      <div className="grid sm:grid-cols-2 gap-4">
        <a href="https://discord.gg/Frbjdmtbrt" target="_blank" rel="noopener noreferrer"
          className="card p-5 flex items-center gap-4 hover:border-brand-700/60 transition-all group">
          <div className="w-10 h-10 rounded-lg bg-[#5865F2]/20 border border-[#5865F2]/30 flex items-center justify-center flex-shrink-0">
            {ICONS.discord}
          </div>
          <div className="flex-1">
            <p className="font-semibold text-white text-sm group-hover:text-brand-300 transition-colors">Discord</p>
            <p className="text-xs text-gray-500">Join our community &amp; open a ticket</p>
          </div>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="w-4 h-4 text-gray-600 flex-shrink-0">
            <path d="M7 17L17 7M7 7h10v10" />
          </svg>
        </a>
      </div>
    </div>
  );
}

export default PageIntroduction;
